import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import CalendarBody from './CalendarBody';
import CalendarHeader from './CalendarHeader';
import { MrbContext } from '../../../../Context/MrbContext'

import './style.scss';

/**
 * @callback onActionCb
 */

/**
 * @callback updateRangeCb
 */

/**
 * Calendar Body
 * @param {MRB.Response} data
 * @param {Array<Moment>} range
 * @param {onActionCb} onAction
 * @param {updateRangeCb} updateRange
 * @returns {JSX.Element}
 * @constructor
 */

function Calendar({ day, handleDayChange, range, onAction, updateRange, updateSort, isPermissionAvailable }) {

  return (
    <MrbContext.Consumer>
      {value =>
        <div className="calendar">
          <CalendarHeader day={day} onChange={handleDayChange} />
          <CalendarBody day={day} data={value?.data} range={range} onAction={onAction} updateSort={updateSort} 
          isPermissionAvailable={isPermissionAvailable}/>
        </div>
      }
    </MrbContext.Consumer>
  );
}

Calendar.propTypes = {
  day: PropTypes.any,
  handleDayChange: PropTypes.func,
  range: PropTypes.array,
  onAction: PropTypes.func.isRequired,
  updateRange: PropTypes.func,
  updateSort: PropTypes.func,
  isPermissionAvailable: PropTypes.func
};

export default React.memo(Calendar);
